<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">عنوان نوع التبرع</h5>

                       <span> بالرجاء التأكد من ملئ الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "donationtypeForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> اسم نوع التبرع</label>
                                <input class="form-control" id="validation01" type="text" formControlName="title"
                                [tooltip]="fc.title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.title.valid && (fc.title.touched)"
                                [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                                
                                     required
                                     placeholder="اسم نوع التبرع"
                                    containerClass="" />
                            </div>
                           <div class="col-6 mb-3">
                                <label for="validationCustom05"><span class="validation-required">*</span> نوع التبرع الرئيسي </label>
                                <ng-select #Governorate  [selectOnTab]="true" formControlName="donationMainTypeId"
                                    class="form-control p-0" placeholder="اختر نوع التبرع الرئيسي "
                                    containerClass="" 
                                    id="validationCustom05">
                                    <ng-option *ngFor="let item of donationmaintype" [value]="item.id">{{item.title}}</ng-option>
                                </ng-select>
                            </div>
                            <div class="col-6 mb-3">
                                <label for="validationCustom05"><span class="validation-required">*</span> فئة التبرع </label>
                                <ng-select #Governorate  [selectOnTab]="true" formControlName="donationCategoryId"
                                    class="form-control p-0" placeholder="اختر فئة التبرع"
                                    containerClass="" 
                                    id="validationCustom05">
                                    <ng-option *ngFor="let item of donationcategory" [value]="item.id">{{item.title}}</ng-option>
                                </ng-select>
                            </div>


                            <div class="col-6 mb-3">
                            <label for=""><span class="validation-required">*</span> تم الابلاغ  ؟</label><br>
                            <input type="radio" class="mx-3" [value]= "true" formControlName="isNotify" ><label class="mx-2" for=""> نعم  </label><br>
                            <input type="radio" class="mx-3" [value]= "false" formControlName="isNotify"><label class="mx-2" for="">لا</label>
                        </div>
                            <!-- <div class="col-6 form-row mb-3">
                                <label ><span class="validation-required">*</span> Is Notify ? </label>
                            <div class="col-2 text-center my-3">
                                <label class="mt-3 p-2"  for="validation10"><span class="validation-required"></span> True</label>
                                <input   id="validation10" type="radio" [value]="true" formControlName="isNotify" />
                            </div>
                            <div class="col-2  text-center my-3 ">
                                <label class="mt-3 p-2" for="validation11"><span class="validation-required"></span> False</label>
                                <input  id="validation11" type="radio" [value]="false" formControlName="isNotify" />
                            </div>
                        </div> -->
                   </div>
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn  pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn  pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

